import { render } from "./homePage.vue?vue&type=template&id=07cea834&scoped=true"
import script from "./homePage.vue?vue&type=script&lang=js"
export * from "./homePage.vue?vue&type=script&lang=js"

import "./homePage.vue?vue&type=style&index=0&id=07cea834&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cea834"]])

export default __exports__